export default "__VITE_ASSET__TEajoE9iH6TNg5Q04itnFA__"